import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

import type { CurrencyConfig } from '../Money/types';

const CurrencyLocaleContext = createContext<Record<string, CurrencyConfig>>({});
export const CurrencyFormatProvider = ({
  value = {},
  children,
}: {
  value: Record<string, CurrencyConfig>;
  children: ReactNode;
}) => (
  <CurrencyLocaleContext.Provider value={value}>
    {children}
  </CurrencyLocaleContext.Provider>
);

export const useCurrencyFormat = () => {
  return useContext(CurrencyLocaleContext);
};
